import { capitalize, get, toUpper } from "lodash"
import { getContributorDescriptors, getIncludeNotHeldParameter, getQueryParameters, getSimulateActionsNode, getUsageParameters, getAnalyticsOutputParameter } from "./helpers"
import { FACTOR_SENSITIVITY_TYPES, factorSensitivityParametersString } from "helpers/factorSensitivity"

export function factorSensitivityQuery(factorSensitivityType, options = {}) {
  const parameters = [getAnalyticsOutputParameter(options)]
  return `query (${getQueryParameters(parameters)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode(parameters)} {
        ${factorSensitivityQueryFragment(factorSensitivityType, options)}
      }
    }
  }`
}

export function factorSensitivityQueryFragment(factorSensitivityType, options = {}) {
  return `${factorSensitivityType}FactorSensitivity: factorSensitivity(${factorSensitivityParametersString(get(FACTOR_SENSITIVITY_TYPES, toUpper(factorSensitivityType)))} ${getUsageParameters(options)}) {
      factors {
        id
        name
        category
        value: sensitivity
      }
    }`
}

export function factorSensitivityContributorsQuery(factorSensitivityType, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${factorSensitivityContributorsQueryFragment(factorSensitivityType, [includeNotHeldParameter])}
      }
    }
  }`
}

export function factorSensitivityContributorsQueryFragment(factorSensitivityType, parameters = []) {
  return `${factorSensitivityType}FactorSensitivityContributors: factorSensitivityContributors(${factorSensitivityParametersString(get(FACTOR_SENSITIVITY_TYPES, toUpper(factorSensitivityType)))} ${getUsageParameters(parameters)}){
      ${getContributorDescriptors()}
      factors{
        id
        name
        category
        value: sensitivity
      }
    }`
}

export function groupedFactorSensitivityContributorsQuery(factorSensitivityType, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter], true)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${groupedFactorSensitivityContributorsQueryFragment(factorSensitivityType, [includeNotHeldParameter])}
      }
    }
  }`
}

export function groupedFactorSensitivityContributorsQueryFragment(factorSensitivityType, parameters = []) {
  return `grouped${capitalize(factorSensitivityType)}FactorSensitivityContributors: groupedFactorSensitivityContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${factorSensitivityParametersString(get(FACTOR_SENSITIVITY_TYPES, toUpper(factorSensitivityType)))} ${getUsageParameters(parameters)}){
      id
      name
      factors{
        id
        name
        category
        value: sensitivity
      }
      contributors{
        ${getContributorDescriptors()}
        factors{
          id
          name
          category
          value: sensitivity
        }
      }
    }`
}
